import { render, staticRenderFns } from "./PageActionLastUser.vue?vue&type=template&id=0c0a363c&scoped=true"
import script from "./PageActionLastUser.vue?vue&type=script&lang=js"
export * from "./PageActionLastUser.vue?vue&type=script&lang=js"
import style0 from "./PageActionLastUser.vue?vue&type=style&index=0&id=0c0a363c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a363c",
  null
  
)

export default component.exports